import { Metric } from "web-vitals";

function reportHandler(metric: Metric): void {
  console.log(metric);
}

export default reportHandler;
